import { render, staticRenderFns } from "./MomentFeedCard.vue?vue&type=template&id=d551ea7a&scoped=true"
import script from "./MomentFeedCard.vue?vue&type=script&lang=js"
export * from "./MomentFeedCard.vue?vue&type=script&lang=js"
import style0 from "./MomentFeedCard.vue?vue&type=style&index=0&id=d551ea7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d551ea7a",
  null
  
)

export default component.exports